import httpClient from './httpClient'

const { recordRequestTrace } = require('../utils/requestTraceRecorder')
const userContext = require('./userContext')

const API_BASE_URL = '/api'

function buildTraceMeta (name, url, payload = null) {
  return {
    name,
    url,
    payload,
    userId: userContext.getCurrentUserId()
  }
}

export default {
  async bootstrapUserSession () {
    try {
      recordRequestTrace(buildTraceMeta('bootstrap', `${API_BASE_URL}/user-config/bootstrap`))
      const response = await httpClient.get(`${API_BASE_URL}/user-config/bootstrap`)
      return response.data
    } catch (error) {
      console.error('用户 bootstrap 失败:', error)
      throw error
    }
  },
  async getStarList () {
    try {
      const response = await httpClient.get(`${API_BASE_URL}/astrolabe/generate/stars`, null)
      return response.data
    } catch (error) {
      console.error('获取恒星基础信息失败:', error)
      throw error
    }
  },
  async getPlanetList () {
    try {
      const response = await httpClient.get(`${API_BASE_URL}/astrolabe/generate/planets`, null)
      return response.data
    } catch (error) {
      console.error('获取行星基础信息失败:', error)
      throw error
    }
  },
  async getLogicPointList () {
    try {
      const response = await httpClient.get(`${API_BASE_URL}/astrolabe/generate/logicPoints`, null)
      return response.data
    } catch (error) {
      console.error('获取逻辑点基础信息失败:', error)
      throw error
    }
  },
  async generateAstrolabe (data) {
    try {
      recordRequestTrace(buildTraceMeta('generate', `${API_BASE_URL}/astrolabe/generate`, data))
      const response = await httpClient.post(`${API_BASE_URL}/astrolabe/generate`, data)
      return response.data
    } catch (error) {
      console.error('生成星盘失败:', error)
      throw error
    }
  },
  async generateAstrolabeBundle (data) {
    try {
      recordRequestTrace(buildTraceMeta('generate-bundle', `${API_BASE_URL}/astrolabe/generate-bundle`, data))
      const response = await httpClient.post(`${API_BASE_URL}/astrolabe/generate-bundle`, data)
      return response.data
    } catch (error) {
      console.error('批量生成星盘失败:', error)
      throw error
    }
  },
  async getPlanetPowerList (data) {
    try {
      recordRequestTrace(buildTraceMeta('power', `${API_BASE_URL}/astrolabe/power/calculate`, data))
      const response = await httpClient.post(`${API_BASE_URL}/astrolabe/power/calculate`, data)
      return response.data
    } catch (error) {
      console.error('生成星盘失败:', error)
      throw error
    }
  },
  async getPlanetPowerDetail (planetIndex, data) {
    try {
      recordRequestTrace(buildTraceMeta('detail', `${API_BASE_URL}/astrolabe/detail/${planetIndex}`, data))
      const response = await httpClient.post(`${API_BASE_URL}/astrolabe/detail/${planetIndex}`, data)
      return response.data
    } catch (error) {
      console.error('获取行星力量详情失败:', error)
      throw error
    }
  },
  async fateCalculate (data) {
    try {
      recordRequestTrace(buildTraceMeta('fate', `${API_BASE_URL}/astrolabe/fateCalculate`, data))
      const response = await httpClient.post(`${API_BASE_URL}/astrolabe/fateCalculate`, data)
      return response.data
    } catch (error) {
      console.error('计算真太阳时失败:', error)
      throw error
    }
  },
  async saveConfig (config) {
    try {
      recordRequestTrace(buildTraceMeta('save-config', `${API_BASE_URL}/user-config/current`, config))
      const response = await httpClient.post(`${API_BASE_URL}/user-config/current`, config)
      return response.data
    } catch (error) {
      console.error('保存配置失败:', error)
      throw error
    }
  },
  async loadConfig () {
    try {
      recordRequestTrace(buildTraceMeta('load-config', `${API_BASE_URL}/user-config/load`))
      const response = await httpClient.post(`${API_BASE_URL}/user-config/load`)
      return response.data
    } catch (error) {
      console.error('加载配置失败:', error)
      throw error
    }
  },
  /**
   * 某本地时刻十颗行星的绝对黄经（星盘免鉴权接口）。
   * 供「相位搜索」逐日取数：老规则固定取北京时间 01:00，即 hour=1 / timezone=8。
   * @param {String} date yyyy-MM-dd
   * @param {Number} hour 本地小时（默认 1）
   * @param {Number} timezone 时区偏移，东区为正（默认 8）
   */
  async getPlanetLongitudes (date, hour = 1, timezone = 8) {
    try {
      recordRequestTrace(buildTraceMeta('planet-longitudes', `${API_BASE_URL}/planet-longitudes`, { date, hour, timezone }))
      const response = await httpClient.get(`${API_BASE_URL}/planet-longitudes`, {
        params: { date, hour, timezone }
      })
      return response.data
    } catch (error) {
      console.error('获取行星黄经失败:', error)
      throw error
    }
  },
  /** 区间起点日之后最近一次全食的日食日期（星盘免鉴权接口） */
  async getNextSolarEclipse (date, hour = 1, timezone = 8) {
    try {
      recordRequestTrace(buildTraceMeta('eclipse-solar', `${API_BASE_URL}/eclipse/next-solar`, { date, hour, timezone }))
      const response = await httpClient.get(`${API_BASE_URL}/eclipse/next-solar`, {
        params: { date, hour, timezone }
      })
      return response.data
    } catch (error) {
      console.error('获取最近日食失败:', error)
      throw error
    }
  },
  /** 区间起点日之后最近一次全食的月食日期（星盘免鉴权接口） */
  async getNextLunarEclipse (date, hour = 1, timezone = 8) {
    try {
      recordRequestTrace(buildTraceMeta('eclipse-lunar', `${API_BASE_URL}/eclipse/next-lunar`, { date, hour, timezone }))
      const response = await httpClient.get(`${API_BASE_URL}/eclipse/next-lunar`, {
        params: { date, hour, timezone }
      })
      return response.data
    } catch (error) {
      console.error('获取最近月食失败:', error)
      throw error
    }
  }
}
